import { Component, OnInit } from '@angular/core';
import { PolicyService } from '../../../policy/services/policy.service';
import Policy from '../../../../core/data/models/policy.mode';
import VehiclePolicy from '../../../../core/data/models/vehicle.policy.model';
import { ClaimService } from '../../services/claim.service';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { PolicyStepComponent } from '../components/policy-step/policy-step.component';
import { FormStepComponent } from '../components/form-step/form-step.component';
import { VehicleStepComponent } from '../components/vehicle-step/vehicle-step.component';
import { Location } from '@angular/common';
import { SharedModule } from '../../../../common/shared.module';
import { policyMask } from '../../../../common/constants/masks';
import { ClaimRateComponent } from '../components/claim-rate/claim-rate.component';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';
import { SwalService } from '../../../../common/services/swal.service';
import PolicyTypes from '../../../../common/enums/policyTypes';

@Component({
    selector: 'app-claim-create',
    providers: [PolicyService, ClaimService],
    imports: [
        NgbProgressbarModule,
        PolicyStepComponent,
        FormStepComponent,
        VehicleStepComponent,
        SharedModule,
        ClaimRateComponent,
    ],
    templateUrl: './claim-create.component.html',
    styleUrl: './claim-create.component.css'
})
export class ClaimCreateComponent implements OnInit {
  policies: Policy[] = [];
  idNumber?: string;

  policySelected: Policy | null = null;
  vehiclePolicySelected: { policy: VehiclePolicy; unitNumber: number } | null =
    null;

  activeStep = 1;
  policyMask = policyMask;
  claimId: string = '';
  PolicyType = PolicyTypes;

  constructor(
    private location: Location,
    private authService: AuthService,
    private route: ActivatedRoute,
    private swalService: SwalService,
  ) {}

  totalSteps = 4;

  get stepsArray(): number[] {
    return Array.from({ length: this.totalSteps }, (_, i) => i + 1);
  }

  get progressValue() {
    return this.activeStep * 25;
  }

  get stepTitle() {
    const titles: Record<number, string> = {
      1: 'Selección de póliza',
      2: 'Selección de vehículo',
      3: 'Información del reclamo',
      4: 'Reclamo aperturado',
    };
    return titles[this.activeStep] ?? '';
  }

  get isIntermediary() {
    return this.authService.isIntermediary;
  }

  ngOnInit() {
    if (this.isIntermediary) {
      const clientId = this.route.snapshot.queryParams['client'];

      if (!clientId) {
        this.swalService.notification('No se pudo obtener el cliente');
        return;
      }

      this.idNumber = clientId;
    }
  }

  onFormCompleted(id: string) {
    this.claimId = id;
    this.nextStep();
  }

  nextStep() {
    if (this.activeStep < 4) {
      this.activeStep += 1;
    }
  }

  onPolicySelected = (policy: Policy) => {
    this.policySelected = policy;
    this.nextStep();
  };

  onVehiclePolicySelected = (policy: {
    policy: VehiclePolicy;
    unitNumber: number;
  }) => {
    this.vehiclePolicySelected = policy;
    this.nextStep();
  };

  onBackPressed() {
    if (this.activeStep >= 2) {
      this.activeStep -= 1;
    } else {
      this.location.back();
    }
  }
}
